import { useTranslation } from 'react-i18next';

import thinkingIcon from '@/assets/icons/thinking.svg';

export const ThinkingIndicator = () => {
  const { t } = useTranslation();
  return (
    <div className="flex justify-start wrap-break-word">
      <div className="flex items-center gap-2 rounded-xl border-[0.42px] border-transparent bg-transparent px-3 py-2">
        <img alt={t('assistant.thinkingAlt')} className="icon-themed" src={thinkingIcon} />
        <p className="shimmer-text text-neutral-mid text-[10px] leading-[170%]">
          {t('assistant.thinking')}
        </p>
      </div>
    </div>
  );
};
